/** @deprecated */
export const buttonStyleMap = {
    primary: 'text-white bg-primary-main hover:bg-primary-hover active:bg-primary-active',
    secondary: 'text-primary-main bg-main-divider hover:text-white hover:bg-primary-hover active:bg-primary-active',
    white: 'text-primary-main bg-white hover:text-white hover:bg-primary-hover active:bg-white active:text-primary-main',
    link: 'text-primary-main',
    transparent: '',
    gray: 'text-primary-main bg-main-divider hover:text-white hover:bg-primary-hover active:bg-primary-active',
    '': '',
};
const DisabledStyle = 'bg-main-divider text-main-disabled';
/** @deprecated */
export const buttonDisabledStyleMap = {
    primary: DisabledStyle,
    secondary: DisabledStyle,
    white: DisabledStyle,
    link: '',
    transparent: '',
    gray: DisabledStyle,
    '': '',
};
/** @deprecated */
export const buttonStyle = 'text-center font-sans select-none';
/** @deprecated */
export const iconStyleMap = {
    primary: 'group-hover/btn:brightness-0 group-hover/btn:invert',
    secondary: 'group-hover/btn:brightness-0 group-hover/btn:invert',
    white: 'group-hover/btn:brightness-0 group-hover/btn:invert',
    link: 'text-primary-main',
    transparent: '',
    gray: 'group-hover/btn:brightness-0 group-hover/btn:invert',
    '': '',
};
//# sourceMappingURL=buttonClassNameConstants.js.map